import { AfterViewInit, Component, OnInit, OnDestroy, inject, signal, computed, effect } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { EcorrUsaBannerComponent } from '@/common/components/ecorr-usa-banner/ecorr-usa-banner.component';
import { HeaderFaqDialogData } from '../../dialogs/header-faq-dialog/header-faq-dialog-data';
import { HeaderFaqDialogService } from '../../services/header-faq-dialog.service';
import { Languages, LanguageService } from '../../../common/services/language.service';
import { HeaderFaq } from '@/landing/dialogs/header-faq-dialog/header-faq';

@Component({
    selector: 'app-ecorr-sc24-header',
    templateUrl: './ecorr-sc24-header.component.html',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatFormFieldModule,
        MatButtonModule,
        MatIconModule,
        MatToolbarModule,
        TranslateModule,
        EcorrUsaBannerComponent
    ]
})
export class EcorrSC24HeaderComponent implements OnInit, AfterViewInit, OnDestroy {

    // Services using inject()
    private languageService = inject(LanguageService);
    private headerFaqDialogService = inject(HeaderFaqDialogService);

    // Signals for reactive state
    loading = signal(false);
    currentUrl = signal<any>('');
    selectedLanguage = signal<string>('en');
    language = signal<Languages | null>(null);
    faqs = signal<HeaderFaq[]>([]);

    // Computed signals
    availLangs = computed(() => this.languageService.availLang());

    // Other properties
    dropdownIcon = '/assets/img/arrow_drop_down.svg';
    languageSub$: Subscription;
    languageControl = new FormControl();

    ngOnInit() {
        this.languageSub$ = this.languageService.language$.subscribe({
            next: (res) => {
                this.language.set(res);
                this.selectedLanguage.set(res.languageCode);
                this.getFAQs();
            },
            error: (err) => {
              console.log(err);
            }
        })
    }

    ngAfterViewInit(): void {
        this.languageControl.valueChanges.subscribe((languageCode) => {
            this.languageService.setLanguage(languageCode);
        });
    }

    updateLanguage() {
        this.languageService.setLanguage(this.selectedLanguage() === 'en' ? 'es' : 'en');
    }

    ngOnDestroy() {
        if (this.languageSub$) {
            this.languageSub$.unsubscribe();
        }
    }

    focusOnMain() {
        const mainContent: HTMLElement = document.querySelector('#main');
        if (mainContent) {
            mainContent.focus();
        }
    }

    getFAQs(): void {
        const faqsArray: HeaderFaq[] = [];
        let translations = this.languageService['translate'].instant('sc24Dialogs.faqDialog.faqs');
        for (let translation of translations){
            let question = translation.question;
            let answer = translation.answer;
            faqsArray.push({question: question, answer: answer, show: false});
        }
        this.faqs.set(faqsArray);
    }
      
    onFAQOpen():void {
        this.getFAQs();
        const options: HeaderFaqDialogData = {
            title: this.languageService.getTranslation('sc24Dialogs.faqDialog.title'),
            closeButtonLabel: this.languageService.getTranslation('sc24Dialogs.closeLabel'),
            dialogClass: 'sc-dialog',
            faq: this.faqs()
        };
        this.headerFaqDialogService.open(options);
    }

}
